import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
} from "react-bootstrap";
import {
  IconStar,
  IconStarFilled,
  IconThumbUpFilled,
  IconThumbDownFilled,
} from "@tabler/icons-react";
import logo from "../../../assets/logo.svg";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import Modal from "react-bootstrap/Modal";

const options = [
  { label: "Fast And Timely Service", value: "liked_fast_service" },
  { label: "Easy And Smooth Process", value: "liked_easy_process" },
  { label: "Good Value For Money", value: "liked_good_value" },
  { label: "High Product/Service Quality", value: "liked_high_quality" },
  { label: "Excellent Support After Purchase", value: "liked_support_after" },
];

function View_FeedbackDetail() {
  const [orderRating, setOrderRating] = useState(null); // 0-10
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [additionalFeedback, setAdditionalFeedback] = useState("");
  const [orderId, setOrderId] = useState("");
  const [feedbackData, setFeedbackData] = useState(null);

  const { postData: fetchReview, data: fetchedReview } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_FEEDBACK
  );

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    const newUrl = window.location.pathname;
    window.history.pushState(null, "", newUrl);
  };

  useEffect(() => {
    if (window.location.search) {
      const orderId = window.location.search.slice(1);
      setOrderId(orderId);
      fetchReview({ order_id: orderId });
    }
  }, [window.location.search]);

  useEffect(() => {
    if (fetchedReview?.data) {
      const data = fetchedReview.data;
      setFeedbackData(data);
      setShow(true);

      const likedOptions = options
        .filter((opt) => data[opt.value] === 1)
        .map((opt) => opt.value);

      setSelectedOptions(likedOptions);
      setOrderRating(data?.order_rating)
      setAdditionalFeedback(data?.additional_feedback)
    }
  }, [fetchedReview]);

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => {
      const starValue = index + 1;
      return (
        <span
          key={starValue}
          style={{
            color: starValue <= rating ? "#FFA500" : "#6C7A91",
            fontSize: "1.2rem",
            marginRight: "2px",
          }}
        >
          {starValue <= rating ? (
            <IconStarFilled size={20} />
          ) : (
            <IconStar size={20} />
          )}
        </span>
      );
    });
  };

  return (
    <Modal show={show} onHide={handleClose}  size="lg">
      <Modal.Header
        className="rating_head gap-2 justify-content-between p-0 position-relative"
        closeButton
      ></Modal.Header>
      <Modal.Body>
        <Card className="feedback_from">
          <Card.Header className="d-flex align-items-center justify-content-between p-4">
            <div>
              <h2> Order ID: #{orderId}</h2>
            </div>
            <img src={logo} alt="logo" />
          </Card.Header>
          <Card.Body className="p-4">
            <Form>
              <Form.Group className="mb-4">
                <Form.Label>
                  <b> How would you rate our order?</b>
                </Form.Label>
                <div className="order-rating-container">
                  <div className="numbers">
                    {Array.from({ length: 11 }, (_, i) => (
                      <button
                        key={i}
                        type="button"
                        className={`number-box ${
                          orderRating !== null && i <= orderRating
                            ? "active"
                            : ""
                        }`}
                        // onClick={() => setOrderRating(i)}
                      >
                        {i}
                      </button>
                    ))}
                  </div>
                  <div className="bar">
                    <div className="labels">
                      <span>Poor</span>
                      <span>Excellent</span>
                    </div>
                  </div>
                </div>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>
                  <b>How would you rate quality of products?</b>
                </Form.Label>
                <div className="stars">
                  {renderStars(feedbackData?.product_quality_rating)}
                </div>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>
                  <b>How would you rate our logistics?</b>{" "}
                </Form.Label>
                <div className="stars">
                  {renderStars(feedbackData?.logistics_rating)}
                </div>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>
                  <b>What did you like about our service?</b>{" "}
                </Form.Label>
                {options.map((opt) => (
                  <Form.Check
                    className="mb-2"
                    key={opt.value}
                    type="checkbox"
                    id={opt.value}
                    label={opt.label}
                    value={opt.value}
                    checked={selectedOptions.includes(opt.value)}
                    // disabled
                  />
                ))}
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>
                  <b>Would you recommend our company to others?</b>
                </Form.Label>
                <div className="recommend-buttons">
                  <button
                    type="button"
                    className={`recommend-button ${
                      feedbackData?.would_recommend === 1 ? "active" : ""
                    }`}
                    // onClick={() => setRecommend("yes")}
                  >
                    <IconThumbUpFilled
                      size={20}
                      color={
                        feedbackData?.would_recommend === 1 ? "#FF6600" : "#999"
                      }
                    />
                    <span>Yes</span>
                  </button>
                  <button
                    type="button"
                    className={`recommend-button ${
                      feedbackData?.would_recommend === 0 ? "active" : ""
                    }`}
                    // onClick={() => setRecommend("no")}
                  >
                    <IconThumbDownFilled
                      size={20}
                      color={
                        feedbackData?.would_recommend === 0 ? "#FF6600" : "#999"
                      }
                    />
                    <span>No</span>
                  </button>
                </div>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>
                  <b>
                    Do you have any additional feedback or suggestions for us?
                  </b>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Type your feedback here..."
                  style={{ height: "100px" }}
                  value={additionalFeedback}
                  // onChange={(e) => setAdditionalFeedback(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
}

export default View_FeedbackDetail;
